import { ReactElement } from "react";
import { IIconProps } from "../types";
import { useStyles } from "./Copy.styled";

// https://uxwing.com/copy-link-icon/
export default function Copy({ color, size }: IIconProps): ReactElement {
  const { classes } = useStyles({ color, size });

  return (
    <svg
      className={classes.icon}
      height={size || 20}
      width={size || 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.41683 12.7083C4.61141 12.7083 3.9585 12.0554 3.9585 11.25V5.62498C3.9585 4.7045 4.70469 3.95831 5.62516 3.95831H11.2502C12.0556 3.95831 12.7085 4.61123 12.7085 5.41665"
        stroke={color || "currentColor"}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3748 7.29169H8.95817C8.0377 7.29169 7.2915 8.03788 7.2915 8.95835V14.375C7.2915 15.2955 8.0377 16.0417 8.95817 16.0417H14.3748C15.2953 16.0417 16.0415 15.2955 16.0415 14.375V8.95835C16.0415 8.03788 15.2953 7.29169 14.3748 7.29169Z"
        stroke={color || "currentColor"}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
